export default __webpack_public_path__ + "images/PM.d19f1ad.png";